/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartFunnel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v18h18v2H2V2zm18 0v2c-1.588 0-2.722 1.513-3.405 4.243a20.786 20.786 0 0 0-.52 3.278l-.041.567-.014.266-.017.455L18 13v5h-8v-5l-.01-.394a23.055 23.055 0 0 0-.065-1.085 20.786 20.786 0 0 0-.52-3.278c-.66-2.636-1.74-4.137-3.242-4.238L6 4V2zm-6 12h-4v2h4zm.388-5h-4.776a24.62 24.62 0 0 1 .352 3.001h4.072a26.193 26.193 0 0 1 .352-3zm1.872-5H9.74c.58.799 1.04 1.813 1.397 3h5.726c.356-1.187.818-2.201 1.397-3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartFunnel as ChartFunnel };
